import { ROUTE } from "../../../routes";
import SharedPropsService from "../../../SharedPropsService";
import { api } from "../../../configs/api";
import { APP_CONFIG, defaultHeaders } from "../../../configs/config";
import { ACTION } from "./types";
import AsyncStorage from "@react-native-async-storage/async-storage";
export const GetMandateLink = async (action, _datastore, { navigate, setDatastore }) => {
    await setDatastore(action.routeId, "progressItem", {
        count: 0,
    });
    let applicationId = '';
    if (await AsyncStorage.getItem("application_id") !== null) {
        applicationId = await AsyncStorage.getItem("application_id");
    }
    else {
        applicationId = (await SharedPropsService.getUser())
            .linkedApplications[0].applicationId;
    }
    const requestOptions = {
        method: "GET",
        headers: await defaultHeaders(),
    };
    const apiPollerRef = setInterval(() => fetch(`${api.agreementLink}${applicationId}`, requestOptions)
        .then((response) => {
        if (response.status === 200) {
            clearInterval(apiPollerRef);
            setDatastore(action.routeId, "progressItem", {
                count: 100,
            });
            navigate(ROUTE.BAJAJ_AGREEMENT_STEPPER);
            return response.json();
        }
    })
        .then((response) => {
        if (response.status === 'SUCCESS') {
            // will change this block later as we need to rewrite the above logic handling encryption
        }
    })
        .catch((error) => console.log("error", error)), APP_CONFIG.POLLING_INTERVAL);
};
export const goBack = async (action, _datastore, { navigate }) => {
    await navigate(ROUTE.KYC_STEPPER, {});
};
export const MandateLinkPoll = async (action, _datastore, props) => {
    await GetMandateLink({ type: ACTION.AUTOPAY, routeId: ROUTE.LOAN_AUTOPAY, payload: {} }, {}, props);
};
